import React, { useContext } from 'react';
import MenuButton from '@components/controls/MenuButton';
import LogoutIcon from '@mui/icons-material/Login';
import styled from 'styled-components/macro';
import { UserContext } from '@stores/UserContext';
import useCognito from '@as_core/account/useCognito';
import { useNavigate } from 'react-router-dom';

interface PropsI {
  reset: () => void;
}

const debug = false;
const FailedLoadingUserAppData = (props:PropsI) => {
  const {reset} = props;
  const { user } = useContext(UserContext);
  const { logout } = useCognito();
  const navigate = useNavigate();

  if (debug) console.log('Register | user:', user);
  const handleLogout = () => {
    logout(user?.authEmail);
    reset();
    navigate('/user/login');
  };

  return(
      <Container>
        <ErrorMessage>
          <Item>
            You have reached this page as it appears to be some issue with loading your account.
            This is may indicative that the service is down. Please try again later.
          </Item>
          <Item>
            If the application
            is still not responding, please send email to Support@AsedaSciences.com.
          </Item>
        </ErrorMessage>
        <LogoutMessage>
          To exit this app sign-out:
        <MenuButton
          key={'register_logout'}
          text={'Sign Out of Account'}
          icon={<LogoutIcon />}
          onClick={handleLogout}
        />
        </LogoutMessage>
      </Container>
  )
}
export default FailedLoadingUserAppData;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  justify-content: center;
  align-items: center;
  background: ${(p) => p.theme.palette.backgroundPrimary};
`;

const ErrorMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-content: space-between;
  font-size: 16px;
  font-style: italic;
  text-align: center;
  align-items: center;
  width: 400px;
  height: 200px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid ${(p) => p.theme.palette.accentPrimary};
  border-radius: 15px;
`;

const Item = styled.div`
  display: flex;
  padding: 15px 0;
`;

const LogoutMessage = styled.div`
  display: flex;
  height: 24px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  padding-right: 10px;
  color: ${(p) => p.theme.palette.textSecondary };
  margin: 5px;
`;